export const Parking = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M22 9l-2.62 1M4.63 10L2 9M18.25 14h-2.5M8.25 14h-2.5M19.379 10l-.839-4.012A2.501 2.501 0 0016.092 4h-8.08a2.5 2.5 0 00-2.434 1.931L4.627 10'
        ></path>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M3.25 20H5.5A1.5 1.5 0 007 18.5v-1h10v1a1.5 1.5 0 001.5 1.5h2.25c.69 0 1.25-.56 1.25-1.25V13a3 3 0 00-3-3H5a3 3 0 00-3 3v5.75c0 .69.56 1.25 1.25 1.25z'
          clipRule='evenodd'
        ></path>
      </svg>
    </span>
  );
};
